import {KeyLabel} from './key-label.model';
export enum WebStatsStatus {
  PENDING = 'PENDING',
  QUALIFIED = 'QUALIFIED',
  NOT_QUALIFIED = 'NOT_QUALIFIED',
}

export const WebStatsStatusLabels = {
  PENDING: 'Pending',
  QUALIFIED: 'Qualified',
  NOT_QUALIFIED: 'Not Qualified',
};

export const WebStatsStatusKL = () => {
  return Object.keys(WebStatsStatusLabels).map(key => new KeyLabel(key, WebStatsStatusLabels[key]));
};
